module.exports = {
  en: {
    'HRES75UC1': {
      '0': '[HRES75U] Approval of Benefits Request',
      '10': '[HRES75U] Approval of Benefits Request',
      '20': 'No.',
      '30': 'Emp. Code',
      '40': 'Name',
      '50': 'Req. Date',
      '60': 'Benefits',
      '70': 'Unit',
      '80': 'Req. Amount',
      '90': 'Approved Amt.',
      '100': 'Status',
      '110': 'Approved By',
      '120': 'Approved Date',
      '130': 'Approved Remark',
      '140': 'Next Approve'
    },
    'HRES75UC2': {
      '0': 'Approval of Benefits Request',
      '10': 'Emp. Code',
      '20': 'Seq.no',
      '30': 'Approved By',
      '40': 'Approve Date',
      '50': 'Approved Amount',
      '60': 'Unit',
      '70': 'Payment Date',
      '80': 'Voucher No.',
      '90': 'Current Status',
      '100': 'Status',
      '110': 'Approved',
      '120': 'Refused',
      '130': 'Remark',
      '140': 'Maximum Allowance'
    },
    'HRES75UC3': {
      '0': 'History of BF Requisition',
      '10': 'Emp. Code',
      '20': 'For Year',
      '30': 'Benefit Code',
      '40': 'Request Date',
      '50': 'Voucher No.',
      '60': 'Amount Pay',
      '70': 'Unit',
      '80': 'Remark',
      '90': 'History of BF Requisition'
    },
    'HRES75UC4': {
      '0': 'Details of Requisition',
      '10': 'Details of Requisition',
      '20': 'Employee Name',
      '30': 'Requested Date',
      '35': 'Seq. No.',
      '40': 'Type of Benefits',
      '50': 'Type of Relation',
      '60': 'Requested  Amount',
      '70': 'Unit',
      '80': 'Type Pay',
      '90': 'Cash / Rec.by hand',
      '100': 'Via Payroll',
      '110': 'Attach File1.',
      '120': 'Attach File2.',
      '130': 'Attach File3.',
      '140': 'Remark',
      '150': 'History of BF Requisition',
      '160': 'Maximum Allowance',
      '170': 'Name Amt.',
      '180': 'Payment Date From'
    },
    'HRES75UC5': {
      '0': 'Maximum Allowance',
      '10': 'Maximum Allowance',
      '20': 'Employee Name',
      '30': 'Benifits Code',
      '40': 'Maximum Allowance',
      '50': 'by Years',
      '60': 'by Sv.Life',
      '70': 'Description',
      '80': 'Amount',
      '90': 'No. of Time',
      '100': 'Max Allowance Per Case',
      '110': 'Max. Allowance',
      '120': 'Acc. Amount',
      '130': 'Outstanding Balance'
    },
    'HRES75UC6': {
      '0': 'Benefits Limit',
      '10': 'Benefits Limit',
      '20': 'For Benefits Code',
      '30': 'Unit :',
      '40': 'Requisition Condition :',
      '50': 'Benefits Limit',
      '60': 'Relation :',
      '70': 'Effective Date From :',
      '80': 'To :',
      '90': 'Max Allowance :',
      '100': 'Max.Req.time',
      '110': 'Acc.Req.Amount',
      '120': 'Acc.Req.Time',
      '130': 'Balance',
      '140': 'Available Req.time'
    }
  },
  th: {
    'HRES75UC1': {
      '0': '[HRES75U] อนุมัติการเบิกค่าสวัสดิการ',
      '10': '[HRES75U] อนุมัติการเบิกค่าสวัสดิการ',
      '20': 'ลำดับที่',
      '30': 'รหัสพนักงาน',
      '40': 'ชื่อ',
      '50': 'วันที่ขอ',
      '60': 'สวัสดิการ',
      '70': 'หน่วย',
      '80': 'จำนวนขอเบิก',
      '90': 'จำนวนที่อนุมัติ',
      '100': 'สถานะ',
      '110': 'ผู้อนุมัติ',
      '120': 'วันที่อนุมัติ',
      '130': 'หมายเหตุการอนุมัติ',
      '140': 'ผู้อนุมัติลำดับถัดไป'
    },
    'HRES75UC2': {
      '0': 'อนุมัติการเบิกค่าสวัสดิการ',
      '10': 'รหัสพนักงาน',
      '20': 'ลำดับที่อนุมัติ',
      '30': 'อนุมัติโดย',
      '40': 'วันที่อนุมัติ',
      '50': 'จำนวนที่เบิกได้',
      '60': 'หน่วย',
      '70': 'วันที่จ่าย',
      '80': 'หลักฐานการจ่าย',
      '90': 'สถานะปัจจุบัน',
      '100': 'สถานะ',
      '110': 'อนุมัติ',
      '120': 'ไม่อนุมัติ',
      '130': 'หมายเหตุ',
      '140': 'สิทธการเบิกสวัสดิการ'
    },
    'HRES75UC3': {
      '0': 'ประวัติการเบิกค่าสวัสดิการ',
      '10': 'รหัสพนักงาน',
      '20': 'สำหรับปี',
      '30': 'รหัสสวัสดิการ',
      '40': 'วันที่ยี่นคำร้อง',
      '50': 'หลักฐานการจ่าย',
      '60': 'จำนวนเงินเบิกได้',
      '70': 'หน่วย',
      '80': 'หมายเหตุ',
      '90': 'ประวัติการเบิกค่าสวัสดิการ'
    },
    'HRES75UC4': {
      '0': 'รายละเอียดการขอเบิกค่าสวัสดิการ',
      '10': 'รายละเอียดการขอเบิกค่าสวัสดิการ',
      '20': 'ชื่อ- นามสกุล',
      '30': 'วันที่ขอ',
      '35': 'ลำดับที่',
      '40': 'รหัสสวัสดิการ',
      '50': 'ประเภทความสัมพันธ์',
      '60': 'จำนวนที่ขอเบิก',
      '70': 'หน่วย',
      '80': 'ประเภทการจ่าย',
      '90': 'เงินสด / มารับเอง',
      '100': 'ส่งระบบเงินเดือน',
      '110': 'Attach File1.',
      '120': 'Attach File2.',
      '130': 'Attach File3.',
      '140': 'หมายเหตุ',
      '150': 'ประวัติการเบิกค่าสวัสดิการ',
      '160': 'สิทธิการเบิกสวัสดิการ',
      '170': 'ชื่อผู้เบิก',
      '180': 'วันที่จ่าย'
    },
    'HRES75UC5': {
      '0': 'สิทธการเบิกสวัสดิการ',
      '10': 'สิทธการเบิกสวัสดิการ',
      '20': 'ชื่อ- นามสกุล',
      '30': 'รหัสสวัสดิการ',
      '40': 'สิทธการเบิกสวัสดิการ',
      '50': 'ต่อปี',
      '60': 'ตลอดอายุงาน',
      '70': 'รายละเอียด',
      '80': 'จำนวน',
      '90': 'จำนวนครั้ง',
      '100': 'จำนวนเบิกสูงสุดต่อครั้ง',
      '110': 'จำนวนเบิกสูงสุด',
      '120': 'จำนวนเบิกสะสม',
      '130': 'คงเหลือ'
    },
    'HRES75UC6': {
      '0': 'สิทธิการเบิกสวัสดิการ',
      '10': 'สิทธิการเบิกสวัสดิการ',
      '20': 'รหัสสวัสดิการ',
      '30': 'หน่วย',
      '40': 'เงื่อนไขการเบิก',
      '50': 'สิทธิการเบิก',
      '60': 'ความสัมพันธ์',
      '70': 'วันที่มีผลบังคับใช้ ตั้งแต่',
      '80': 'ถึง',
      '90': 'จำนวนที่เบิกสูงสุด',
      '100': 'จำนวนครั้งที่เบิกได้',
      '110': 'จำนวนเบิกสะสม',
      '120': 'จำนวนครั้งเบิกสะสม',
      '130': 'คงเหลือ',
      '140': 'จำนวนครั้งคงเหลือ'
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/labels/hres75u.js